import { css } from 'react-emotion';
import { flex } from 'appStyles';

export const homeContainer = css`
  ${flex};
  position: relative;
  padding: 20px;
  width: 100%;
  height: 100vh;
`;

export const phoneCase = css`
  ${flex};
  width: 350px;
  height: 715px;
  position: relative;
  left: 33vw;
  border-radius: 42px;
  border: .5rem solid;
  overflow: hidden;

  * {
    z-index: 2;
  }
`;

export const phoneChin = css`
  z-index: 3;
  position: absolute;
  top: -2rem;
  ${flex};
  transform: scale(.45) translateX(0rem) translateY(1.5rem);
  overflow: hidden;
`;

export const iphone = css`
  width: 360px;
  position: absolute;
  right: 100px;
  fill-color:blue;

  svg {
    fill: blue;
  }
`;

export const colorPicker = css`
  position: absolute;
  bottom: 8rem;
  right: 2rem;
  z-index: 10;
  opacity: 0;

  &:hover {
    opacity: 1;
  }
`;

export const testButton = css`
  position: absolute;
  ${flex};
  justify-content: flex-start;
  padding: 2rem;
  top: 80vh;
  left: 2vw;
  width: 15rem;
  height: 5rem;
  border-radius: .2rem;
  background: rgba(180,200,240,.8);
  cursor: pointer;
  color: white;
  font-size: 1.3rem;
  transition: .2s;
  z-index: 10;

  &:hover {
    width: 16rem;
    font-size: 1.35rem;
    transition: .3s;
  }
`;
